var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgBottom = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 18,
    height: 18,
    rx: 2,
    fill: "#5C5F62"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.69472 14.6143L15.6155 14.6143C15.9983 14.6143 16.3086 14.9245 16.3086 15.3073C16.3086 15.6901 15.9983 16.0004 15.6155 16.0004L4.69472 16.0004C4.31216 16.0004 4.00167 15.6899 4.00167 15.3073C4.00167 14.9247 4.31216 14.6143 4.69472 14.6143Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 10.1715L9.5 3.36621C9.5 2.952 9.83579 2.61621 10.25 2.61621C10.6642 2.61621 11 2.952 11 3.36621L11 10.1715L13.25 10.1715L10.25 13.164L7.25 10.1715L9.5 10.1715Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBottom, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bottom.d638f758.svg";
export { ForwardRef as ReactComponent };